const Cargando = () => {
  return (
    <div className='text-center mt-3'>
      <i className=' fas fa-compact-disc fa-spin fa-3x'></i>
    </div>
  )
}

export default Cargando
